module.exports = __webpack_public_path__ + "media/images/area/icon_weather_10-1118185c98526b5a583692af09462eae.png";